export default "__VITE_ASSET__ClLx7$hc__"